function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useIsInverseVariant as i } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: r , size: l = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const o = i(), t = r !== null && r !== void 0 ? r : o ? c.colors.inverse : c.colors.neutralHigh;
    return /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: t,
            d: "M19.387 8.152v12.306c0 .75-.636 1.383-1.386 1.383H6.009c-.737 0-1.386-.647-1.386-1.384l.039-3.296-.04-7.972v-5.65c0-.726.662-1.384 1.387-1.384h7.3c.227 0 .448.092.608.252l5.21 5.123a.826.826 0 01.213.384.61.61 0 01.047.238zm-1.384 12.474c.096 0 .191-.096.191-.169V9.024h-2.277c-.998 0-1.86-.33-2.493-.952-.639-.63-.978-1.487-.978-2.482V3.371H6.012c-.073 0-.185.109-.19.168v5.647l.039 7.977-.04 3.3c0 .05.098.16.19.16h11.992v.003zM17.69 7.808l-.003-.003h.003v.003zm-.003-.003l-4.05-3.983v1.764c0 .659.212 1.213.613 1.608.406.4.983.61 1.664.61h1.773zm-2.661 9.91a.605.605 0 00-.77.356l-.241.664-1.16-2.563c.692-.079 1.263-.3 1.703-.673l1.112 2.457-.644-.24zm-3.588-1.568l-1.174 2.59-.244-.663a.602.602 0 00-.767-.356l-.647.244 1.182-2.61c.412.422.969.683 1.65.795zm.823-5.86c1.74 0 2.516.79 2.516 2.56 0 1.767-.776 2.557-2.516 2.557s-2.515-.787-2.515-2.557.776-2.56 2.515-2.56zm4.334 7.776l-1.451-3.208-.013-.019-.007-.009c.291-.512.45-1.165.45-1.977 0-2.294-1.22-3.37-3.313-3.37-2.092 0-3.31 1.076-3.31 3.37 0 .689.12 1.257.333 1.73a.469.469 0 01-.022.029.239.239 0 00-.04.059l-1.538 3.395a.614.614 0 00.079.638c.142.18.375.26.647.196l.935-.35.37 1a.598.598 0 00.53.325h.016a.597.597 0 00.53-.353l1.35-2.983 1.35 2.983a.6.6 0 00.53.353h.016c.221 0 .423-.123.55-.372l.35-.953.982.367a.602.602 0 00.597-.213.614.614 0 00.079-.638zm-4.88-5.541a.348.348 0 00.31-.204l.203-.572.268.577a.355.355 0 00.258.19l.574.057-.428.442a.388.388 0 00-.098.314l.11.58-.46-.255a.334.334 0 00-.356-.017l-.003.003a.198.198 0 00-.02.014c-.006.005-.012.01-.02.014l-.436.288.1-.627a.38.38 0 00-.094-.311l-.451-.406.543-.087zm-1.003.532l.314.322-.07.47a.663.663 0 00.263.653.626.626 0 00.678.04l.373-.207.37.207a.634.634 0 00.674-.04.675.675 0 00.267-.655l-.076-.462.314-.325a.678.678 0 00.154-.684.647.647 0 00-.516-.442l-.42-.064-.193-.415c-.219-.465-.947-.465-1.16 0l-.19.409-.42.064a.646.646 0 00-.516.446.68.68 0 00.154.683z"
        })
    }));
}, v = s;
export { v as default };
